<template>
  <div class="icon-group">
    <el-avatar class="el-icon--right" icon="el-icon-user-solid"></el-avatar>
    <el-dropdown trigger="click">
      <span class="el-dropdown-link" style="color: #000000;">
        <i>{{userName}}</i>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item class="clearfix">
          <el-button type="text" icon="el-icon-edit" @click="changePassword">
            修改密码
          </el-button>
        </el-dropdown-item>
        <el-dropdown-item class="clearfix">
          <el-button type="text" icon="el-icon-warning-outline" @click="quit">
            退出
          </el-button>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 添加编辑弹窗 -->
    <el-dialog title="修改密码" :visible.sync="dialogVisible" append-to-body>
      <el-form
        :model="passwordForm"
        ref="passwordForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
              type="password"
              v-model="passwordForm.oldPassword"
              prefix-icon="icon icon-login_pass"
              placeholder="旧密码"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
              type="password"
              v-model="passwordForm.newPassword"
              prefix-icon="icon icon-login_pass"
              placeholder="新密码"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
              type="password"
              v-model="passwordForm.confirmPassword"
              prefix-icon="icon icon-login_pass"
              placeholder="确认新密码"
              clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="cancel-btn"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitPass('passwordForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
var _self;
import api from "@/api";
export default {
  components: {},
  data() {
    return {
      imgUrl: "",
      passwordForm: {},
      dialogVisible: false,
      userName: "",
      rules: {
        oldPassword: [
          {
            required: true,
            message: "旧密码不能为空！",
            trigger: "blur"
          }
        ],
        newPassword: [
          {
            required: true,
            message: "新密码不能为空！",
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: "确认新密码不能为空！",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    _self = this;
    let user = JSON.parse(window.sessionStorage.getItem(
        "user"
    ));
    _self.userName = user.name;
  },
  mounted() {},
  methods: {
    quit() {
      api.userAPI.logout().then(res => {
        if (res.status == 200) {
          window.sessionStorage.clear();
          this.$router.push("/");
        }
      });
    },
    changePassword() {
      this.$nextTick(() => {
        if (this.$refs.passwordForm) {
          this.$refs.passwordForm.clearValidate();
          this.$refs.passwordForm.resetFields();
        }
      });
      this.dialogVisible = true;
    },
    submitPass() {
      this.$refs["passwordForm"].validate(valid => {
        if (valid) {
          let user = JSON.parse(window.sessionStorage.getItem("user"));
          api.userAPI.userKey({ account: user.account }).then(res => {
            if (res.status == 200) {
              var encrypt = new _self.$jsencrypt();
              encrypt.setPublicKey(res.data.publicKey);
              let oldPassword = encrypt.encrypt(_self.passwordForm.oldPassword);
              let newPassword = encrypt.encrypt(_self.passwordForm.newPassword);
              let confirmPassword = encrypt.encrypt(
                _self.passwordForm.confirmPassword
              );
              let param = {
                oldPassword: oldPassword,
                newPassword: newPassword,
                confirmPassword: confirmPassword
              };

              api.userAPI.changePassword(param).then(resp => {
                if (resp.status == 200) {
                  _self.$message({
                    message: resp.message,
                    type: "success"
                  });
                  _self.quit();
                } else {
                  _self.$message({
                    message: resp.message,
                    type: "error"
                  });
                }
              });
            } else {
              _self.$message({
                message: res.message,
                type: "error"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
